var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CommonDialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.currentConfig.title,
        buttons: _vm.currentConfig.buttons,
        closeable: _vm.type !== "language",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "button-click": _vm.handleButtonClick,
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _vm.type === "review"
          ? _c(
              "div",
              { staticClass: "text-gray-600 text-sm leading-relaxed" },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("home.dialog.tip.reviewDesc1"))),
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("home.dialog.tip.reviewDesc2")) +
                      _vm._s(150) +
                      _vm._s(_vm.$t("home.dialog.tip.reviewDesc3"))
                  ),
                ]),
                _c("p", { staticClass: "text-xs text-gray-500" }, [
                  _vm._v(
                    "(" +
                      _vm._s(_vm.$t("home.dialog.tip.reviewDesc4")) +
                      " RM1.50 " +
                      _vm._s(_vm.$t("home.dialog.tip.reviewDesc5")) +
                      " )"
                  ),
                ]),
              ]
            )
          : _vm.type === "language"
          ? _c(
              "div",
              { staticClass: "text-gray-600 text-sm leading-relaxed" },
              [
                _c("p", [
                  _vm._v(" 请选择您希望使用的语言 "),
                  _c("br"),
                  _vm._v(
                    " Welcome to yoyotravel! Please select your preferred language "
                  ),
                ]),
              ]
            )
          : _vm.type === "password"
          ? _c(
              "div",
              { staticClass: "text-gray-600 text-sm leading-relaxed" },
              [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("home.dialog.tip.passwordDesc"))),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }